var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"position":"relative","overflow":"hidden","padding-top":"80%"}},[(_vm.streamKey)?_c('embed',{staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"src":'https://samples.quanteec.com/samples/?autoplay=true&key=' + _vm.streamKey}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }